module.exports = __webpack_public_path__ + "static/media/user.8253b492.jpg";